import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { StorageService } from '../services/storage-service';
import { type ImageRatioType } from '@/shared/utils';

export const useStorage = {
  /**
   * Mutación para subir imágenes de branding (Logo o Banners) con compresión opcional
   */
  useUploadBranding: () => {
    return useMutation({
      mutationFn: async ({
        file,
        ownerId,
        type,
        ratioType,
      }: {
        file: File;
        ownerId: string;
        type: 'logo' | 'banners' | 'catalog';
        ratioType?: ImageRatioType;
      }) => {
        let finalFile = file;

        // Si se provee un ratioType, comprimimos y optimizamos la imagen
        if (ratioType) {
          finalFile = await StorageService.processImageForUpload(file, ratioType);
        }

        const path = StorageService.generatePath(ownerId, type, finalFile.name);
        return await StorageService.uploadFile(finalFile, path);
      },
      onError: (error) => {
        console.error('Storage Error:', error);
        toast.error('Error al subir la imagen');
      },
    });
  },
};
